import "./GuideLFPIORPI.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import NdiceDeCumplimiento from "./sections/NdiceDeCumplimiento";
import MarcoLegalYReforma2025 from "./sections/MarcoLegalYReforma2025";
import ConsultaAUnExperto from "./sections/ConsultaAUnExperto";
import PieDePGina from "@/reusable_sections/Footer";
export default function GuideLFPIORPIPage() {
  return <div>
      <NavegaciNPrincipal />
      <NdiceDeCumplimiento />
      <MarcoLegalYReforma2025 />
      <ConsultaAUnExperto />
      <PieDePGina />
    </div>;
}